import { Container, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";

import logo from "images/logo.png";
import "styles/navbar-toggler.scss";

export const TopBar = () => (
    <Container className="justify-content-between">
        <Navbar.Brand as={Link} to="/" className="home">
            <img src={logo} alt="Magic AI Booth" aria-label="Magic AI Booth" className="brand-name" />
        </Navbar.Brand>
    </Container>
);
